import { Box, Divider, styled } from '@mui/material';
import { Button } from '../../atoms/Button';
import { TextField } from '../../atoms/TextField';
import { Typography } from '../../atoms/Typography';

export const ContentPaper = styled(Box)`
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: whitesmoke;
`;

export const TravelStartText = styled(Typography)`
  width: 120px;
`;

export const NoTravelText = styled(Typography)`
  font-size: 10px;
  font-weight: 400;
  color: red;
  margin-bottom: 12px;
`;

export const SubmitButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: whitesmoke!important;
`;

export const NotesText = styled(TextField)`
  flex-grow: 1;
`;

export const StyledDivider = styled(Divider)`
  margin-top: 20px;
  margin-bottom: 20px;
`;